import { ElementInfo } from "./controls";

export type Branded<A, B> = A & { __brand: B };

type P5Func = () => void;

export function RegisterP5Sketch(
	setup: P5Func,
	draw: P5Func,
) {
	Object.assign(window, { setup, draw });
}

const urlParams = new URLSearchParams(window.location.search);

export function GetURLParamOrDefault(
	param: string,
	defaultVal: string
): { Value: string; Default: boolean } {
	const v = urlParams.get(param);
	if (v === null) {
		return { Value: defaultVal, Default: true };
	}
	return { Value: v, Default: false };
}

export function SetOnChangeHandler(
	onChange: () => void,
	elements: ElementInfo<string, any>[]
) {
	const onChangeWrapper = () => {
		const params = elements.map((v) => {
			let value = v.Element.value;
			return [v.Id, value];
		});

		const url = new URL(document.URL);
		url.search = new URLSearchParams(params).toString();
		history.pushState(null, "", url);
		onChange();
	};

	elements.forEach((v) => {
		let { Value } = GetURLParamOrDefault(v.Id, v.DefaultValue);
		v.Element.value = Value;
	});
	elements.forEach((v) => (v.Element.onchange = onChangeWrapper));
}

export function SetupSaveAndShareButton(
	save: HTMLButtonElement,
	share: HTMLButtonElement
) {
	save.onclick = () => {
		saveCanvas("canvas.png");
	};
	share.onclick = () => {
		if (!(navigator.canShare && navigator.canShare())) {
			alert("Share button is not supported in this context");
			return;
		}
		navigator.share({ url: document.URL });
	};
}

export function GetBaseURL() {
	const url = new URL(document.URL);
	url.search = "";
	return url.toString();
}

class ElemCollection<S extends string> {
	private collection: {[K in S]: HTMLElement};
	constructor(c: {[K in S]: HTMLElement}){
		this.collection = c;
	}
	ToType<T extends HTMLElement>(): {[K in S]: T} {
		return this.collection as {[K in S]: T}
	}
}

export function GetElementsById<S extends string>(
	...names: S[]
): ElemCollection<S> {
	const res = {} as any;
	names.forEach(n => res[n] = document.getElementById(n)!)
	return new ElemCollection(res as {[K in S]: HTMLElement});
}

